







































































































































































































import { InfoFichier } from '@/domain/InfosFichier'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import GEDMixin from './GEDMixin'
import Vue from 'vue'
import { FilePartageParMailInput } from './input/FilePartageParMailInput'
import draggable from 'vuedraggable'
import { Dossier } from '@/domain/Dossier'
import { Dictionary } from 'vue-router/types/router'
import { RoleEnum } from '@/domain/role'
import { EnumPermission } from '@/domain/permission'

export default mixins(GEDMixin, mobileTypeMixin).extend({
    components: {
        draggable,
    },
    data() {
        return {
            dossierHover: null as null | Dossier,
            dragging: false,
            canModify: this.$database.account.permissions.indexOf(EnumPermission.File_Write) !== -1
        }
    },
    methods: {
        startDrag(evt: DragEvent, item: Dossier | InfoFichier) {
            if (!evt.dataTransfer) return

            console.log(item, typeof item)
            this.dragging = true

            document.addEventListener(
                'dragend',
                () => {
                    console.log('dragend')
                    this.dragging = false
                },
                { once: true }
            )

            evt.dataTransfer.dropEffect = 'move'
            evt.dataTransfer.effectAllowed = 'move'
            evt.dataTransfer.setData('itemID', item.id.toString())
            evt.dataTransfer.setData('type', 'dossiersEnfant' in item ? 'Dossier' : 'InfoFichier')
        },
        onDrop(evt: DragEvent, dossier: Dossier) {
            if (!evt.dataTransfer) return
            this.dossierHover = null
            this.dragging = false

            const itemID = evt.dataTransfer.getData('itemID')
            const type = evt.dataTransfer.getData('type')

            if (type == 'Dossier') {
                const item = this.dossiers.find((i) => i.id == parseInt(itemID))
                if (!item) return

                item.dossierParentId = dossier.id || null
                this.saveDossier(item)
            } else {
                const item = this.files.find((i) => i.id == parseInt(itemID))
                if (!item) return

                item.dossierId = dossier.id || null
                this.save(item)
            }
        },
        dragEnter(dossier: Dossier, ev: DragEvent) {
            ev.preventDefault()
            this.dossierHover = dossier
        },
        dragLeave(dossier: Dossier, ev: DragEvent) {
            ev.preventDefault()
            if (dossier == this.dossierHover) {
                this.dossierHover = null
            }
        },
        isExcel(file: InfoFichier) {
            return ['xlsx', 'xls', 'csv'].indexOf(file.extension) !== -1
        },
        isWord(file: InfoFichier) {
            return ['doc', 'docx'].indexOf(file.extension) !== -1
        },
        isPDF(file: InfoFichier) {
            return file.extension == 'pdf'
        },
        isImage(file: InfoFichier) {
            return ['png', 'jpeg', 'jpg'].indexOf(file.extension) !== -1
        },
        openPdf(file: InfoFichier) {
            this.navigateToPDFViewer(this.constructFileDownloadUrl(file.identifiantTelechargement))
        },
        openFilePartage() {
            if (!this.fileInfo) return

            this.partageParMail = new FilePartageParMailInput()
            this.partageParMail.idFichier = this.fileInfo.id
            this.partageParMail.identifiantTelechargement = this.fileInfo.identifiantTelechargement

            this.dialogPartage.open()
        },
        canUpload() {
            return [RoleEnum.SuperAdmin].indexOf(this.$database.account.roleEnum) !== -1 &&
                this.$database.account.permissions.indexOf(EnumPermission.File_Write) !== -1
        }
    },
})
